export enum SUPPORT_LINKS_ANALYTICS_ACTIONS {
    GO_SUPPORT = 'go to customer support',
    GO_FAQ = 'view our faq'
}
